import type { Question } from '@mentimeter/legacy-series-types/question';
import type { Slide as VotingSlide } from '../../compatibility-overrides/voting-types';
import type { CompatibilitySlide } from '../../compatibility-types';
import type { CommonQuestionProperty } from './get-common-question-property';

export const getQuestionMiroProperty = (
  target: CompatibilitySlide<'miro'> | VotingSlide<'miro'>,
  prop: keyof Question,
) => {
  const staticContents = target.staticContent;

  switch (prop as keyof Omit<Question, CommonQuestionProperty>) {
    case 'question':
      return staticContents.heading;
    case 'question_description':
      return staticContents.additionalDetails;
    case 'module_custom_data':
      return {
        miro_url: staticContents.url,
        audience_board: staticContents.showBoardToAudience,
      };
    default:
      return undefined;
  }
};
